var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectedOk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6554 0.344577C20.1149 0.804025 20.1149 1.54892 19.6554 2.00837L7.89072 13.7731C7.4313 14.2325 6.68639 14.2325 6.22694 13.7731L0.344577 7.89072C-0.114859 7.4313 -0.114859 6.68636 0.344577 6.22695C0.804025 5.76754 1.54892 5.76754 2.00837 6.22695L7.05883 11.2774L17.9917 0.344577C18.4511 -0.114859 19.196 -0.114859 19.6554 0.344577Z",
    fill: "#00353B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedOk);
export default __webpack_public_path__ + "static/media/selected_ok.2f0565b48c133aa8381612baa30309ec.svg";
export { ForwardRef as ReactComponent };